import CountUp from './count-up.vue';
export default CountUp;


// WEBPACK FOOTER //
// ./src/components/count-up/index.js